import React from 'react';

export const OptimizationIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id="optimizationIconT">optimization icon</title>
            <desc id="optimizationIconD">
                A vector illustration of a optimization icon
            </desc>
            <path
                d="M17.625 23.25H6.375c0-.412.169-.787.439-1.061a1.51 1.51 0 0 1 1.061-.439h8.25a1.5 1.5 0 0 1 1.5 1.5Z"
                fill="#969FAA"
            />
            <path d="M8.625 19.5h6.75v2.25h-6.75V19.5Z" fill="#AAB2BD" />
            <path
                d="M21.75 16.5V18a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-1.5h19.5Z"
                fill="#CCD1D9"
            />
            <path
                d="M3.75 6h16.5a1.5 1.5 0 0 1 1.5 1.5v9H2.25v-9A1.5 1.5 0 0 1 3.75 6Z"
                fill="#69D6F4"
            />
            <path
                d="M18 6v.008a.75.75 0 0 1-.75.75H13.5l-2.104 1.395a.578.578 0 0 1-.896-.48v-.915H6.75a.75.75 0 0 1-.75-.75v-4.5c0-.413.338-.75.75-.75h10.5c.413 0 .75.337.75.75V6ZM23.25 9v6h-4.5V9h4.5Z"
                fill="#E6E9ED"
            />
            <path
                d="M15.75 12.375V15h-1.5v-4.5h1.5v1.875ZM11.25 9.75h1.5V15h-1.5V9.75ZM9.75 11.25V15h-1.5v-3.75h1.5Z"
                fill="#FF826E"
            />
            <path
                d="M3.375 9.75A2.623 2.623 0 0 1 6 12.375a2.623 2.623 0 0 1-3.746 2.374 2.623 2.623 0 0 1-.004-4.744c.341-.165.72-.255 1.125-.255Z"
                fill="#FCD770"
            />
            <path
                d="M3.375 13.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
                fill="#FFEAA7"
            />
            <path
                d="M9 4.884h-.75a.375.375 0 0 1-.375-.375h-.75c0 .62.505 1.125 1.125 1.125H9c.62 0 1.125-.505 1.125-1.125S9.62 3.384 9 3.384h-.75a.375.375 0 0 1 0-.75H9c.207 0 .375.168.375.375h.75c0-.62-.505-1.125-1.125-1.125h-.75c-.62 0-1.125.504-1.125 1.125 0 .62.505 1.125 1.125 1.125H9a.375.375 0 0 1 0 .75ZM12 5.634h1.125v-.75H12a.375.375 0 0 1-.375-.375v-.375h1.5v-.75h-1.5v-.375c0-.207.168-.375.375-.375h1.125v-.75H12c-.62 0-1.125.504-1.125 1.125v1.5c0 .62.505 1.125 1.125 1.125ZM15 5.634h.75c.62 0 1.125-.505 1.125-1.125v-1.5c0-.62-.505-1.125-1.125-1.125H15c-.62 0-1.125.504-1.125 1.125v1.5c0 .62.505 1.125 1.125 1.125Zm-.375-2.625c0-.207.168-.375.375-.375h.75c.207 0 .375.168.375.375v1.5a.375.375 0 0 1-.375.375H15a.375.375 0 0 1-.375-.375v-1.5Z"
                fill="#000"
            />
            <path
                d="M23.625 8.625h-1.5V7.5a1.877 1.877 0 0 0-1.875-1.875h-1.875V1.509c0-.62-.505-1.125-1.125-1.125H6.75c-.62 0-1.125.504-1.125 1.125v4.116H3.75A1.877 1.877 0 0 0 1.875 7.5v2.28a3 3 0 0 0-1.5 2.595 3 3 0 0 0 1.5 2.594V18c0 1.034.841 1.875 1.875 1.875h4.5v1.5h-.375A1.877 1.877 0 0 0 6 23.25v.375h12v-.375a1.877 1.877 0 0 0-1.875-1.875h-.375v-1.5h4.5A1.877 1.877 0 0 0 22.125 18v-2.625h1.5v-6.75ZM6.375 1.509c0-.207.168-.375.375-.375h10.5c.207 0 .375.168.375.375v4.5a.375.375 0 0 1-.375.375h-3.863l-2.2 1.458c-.124.084-.312-.018-.312-.168v-1.29H6.75a.375.375 0 0 1-.375-.375v-4.5ZM2.625 7.5c0-.62.505-1.125 1.125-1.125h1.941c.153.44.567.759 1.059.759h3.375v.54a.952.952 0 0 0 1.477.793l2.01-1.333h3.638c.491 0 .906-.32 1.059-.759h1.941c.62 0 1.125.505 1.125 1.125v1.125h-3V12h-2.25v-1.875h-2.25v4.5h-.75v-5.25h-2.25v5.25h-.75v-3.75h-2.25V12H6.349a3.003 3.003 0 0 0-2.974-2.625c-.26 0-.51.036-.75.099V7.5Zm12 7.125v-3.75h.75v3.75h-.75Zm-2.25 0h-.75v-4.5h.75v4.5Zm-3 0h-.75v-3h.75v3Zm-8.25-2.25c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25-1.01 2.25-2.25 2.25-2.25-1.01-2.25-2.25Zm16.06 10.5H6.816c.154-.436.571-.75 1.06-.75h8.25c.489 0 .906.314 1.06.75ZM15 21.375H9v-1.5h6v1.5Zm5.25-2.25H3.75c-.62 0-1.125-.505-1.125-1.125v-1.125h18.75V18c0 .62-.505 1.125-1.125 1.125Zm1.125-3H2.625v-.849c.24.063.49.099.75.099a3.003 3.003 0 0 0 2.974-2.625h1.526v1.875h-.75v.75h9.75v-.75h-.75V12.75h2.25v2.625h3v.75Zm1.5-1.5h-3.75v-5.25h3.75v5.25Z"
                fill="#000"
            />
            <path
                d="M10.5 18.375a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75ZM12 18.375a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75ZM13.5 18.375a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75ZM4.875 12.375c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5.673 1.5 1.5 1.5 1.5-.673 1.5-1.5Zm-2.25 0a.75.75 0 1 1 1.502.002.75.75 0 0 1-1.502-.002ZM19.875 10.125h2.25v.75h-2.25v-.75ZM19.875 11.625h2.25v.75h-2.25v-.75ZM19.875 13.125h2.25v.75h-2.25v-.75Z"
                fill="#000"
            />
        </svg>
    );
};
